import Popup from '../../Core/Popup';
import { DeviceHelper, Device } from '../../Core/DeviceHelper';

const popup = new Popup();

const FuncionPeliculaPopup = {
    show(salaId, peliculaId) {
        $.get(`/cartelera-de-cine/api/funciones-pelicula/sala/${salaId}/pelicula/${peliculaId}`)
        .then(data => {
            popup.render(data);
            popupEvents();
        });
    }
};

function popupEvents() {
    //Capturamos contenedor principal de todas las fechas que mostraran informacion
    const $detalleContainer = document.querySelector('.detalleFechas__container');

    //Capturamos el active
    const $detalleTituloActivo = document.querySelector('.detalleFechas__container__articulo__titulo.active');

    //Capturamos todas las fechas que mostraran informacion
    const $detalleTitulo = document.querySelectorAll('.detalleFechas__container__articulo__titulo');

    //Recorremos todas las fechas y le asignamos el evento click
    Array.from($detalleTitulo).map((item) => { 
        //Validamos si es desktop/mobile para asignarle la function correspondiente
        if (window.innerWidth < 1024) {
            item.addEventListener('click', function () {
                animacionInMobile(item);
            });
            $detalleTituloActivo.nextElementSibling.style.maxHeight = $detalleTituloActivo.nextElementSibling.scrollHeight + "px";
        } else {
            //Si es desktop, se muestran tres letras por día
            const diaArray = item.innerHTML.split(" ");
            item.innerHTML = `${diaArray[0].substring(0, 3)} ${diaArray[1]}`;
            item.addEventListener('click', function () {
                animacionInDesktop(item);
            });
        }
    });

    //Decalramos la funcion que realizará en mobile
    const animacionInMobile = (item) => {
        item.classList.toggle("active");
        let $detalleDescrip = item.nextElementSibling;
        //El height la declaramos aca porque depende del contenido de cada uno.
        if ($detalleDescrip.style.maxHeight) {
            $detalleDescrip.style.maxHeight = null;
        } else {
            $detalleDescrip.style.maxHeight = $detalleDescrip.scrollHeight + "px";
        }
    };

    //Declaramos la funcion que realizara en desktop
    const animacionInDesktop = (item) => {
        const $descrip = item.nextElementSibling;

        //Removemos para que solo exista donde clickeamos
        Array.from($detalleTitulo).map((elemento) => {
            elemento.classList.remove('active');
        });
        item.classList.add("active");
        $detalleContainer.style.height = $descrip.scrollHeight + 100 + 'px';
    };

    var device = DeviceHelper.GetDevice();
    if (Device.Desktop === device) {
        animacionInDesktop($detalleTituloActivo);
    }
}

export default FuncionPeliculaPopup;


// WEBPACK FOOTER //
// ./Statics/scripts/Modules/Popups/FuncionPeliculaPopup.js